<template>
    <div class="steps" :style="$global.dynamicCols(count)">
        <div :class="`step ${getClass(index)}`" v-for="index in count" :key="index">
        </div>
    </div>
</template>
<script>
export default {
    props: {
        step: {
            type: Number,
            required: true
        },
        count: {
            type: Number,
            required: true,
            default: 1
        }
    },

    methods: {
        getClass(index) {
            return ((index === this.step)
                ? 'active'
                : (index < this.step)
                    ? 'completed' : '');
        }
    }
}
</script>
<style scoped>
.steps {
    width: 100%;
    height: 4px;
    display: grid;
    gap: 0.5rem;
}
.step {
    height: 100%;
    border-radius: 5px;
    background: #F5F5F5;
}
.active {
    background-color: var(--vt-c-text-primary);
}
.completed {
    background-color: var(--vt-c-text-secondary);
}
</style>